import { Component, CreateEffectOptions, Input, Signal, effect, inject, input, output, signal } from '@angular/core';
import { ChartsModule, SeriesClickEvent } from '@progress/kendo-angular-charts';
import { BaseComponent } from '../../../../../../../core/shared/common/base.component';
import { TopFiveData } from '../../../../../../../core/services/analytics.service';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { ChartLabelsPopupService } from '../../../../../../../core/shared/common/chart-labels-popup.service';
import { SuspectAssetsDetailsService } from '../sla-adherence/services/suspectassetsdetails.service';
import { ExcelModule, GridDataResult, GridModule } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { DialogsModule } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-suspect-assets',
  standalone: true,
  imports: [ChartsModule, LoaderModule, CommonModule, GridModule, DialogsModule, ExcelModule],
  templateUrl: './suspect-assets.component.html',
  styleUrl: './suspect-assets.component.scss',
  providers: [SuspectAssetsDetailsService],
})
export class SuspectAssetsComponent extends BaseComponent {
  public gridService = inject(SuspectAssetsDetailsService);
  public popupService = inject(ChartLabelsPopupService);
  @Input() topSuspectAssetsData!: Signal<TopFiveData[]>;
  @Input() topAssetDetailData!: Signal<TopFiveData[]>;
  public seriesClick = output<SeriesClickEvent>();

  public organizationId = input<number | null>();
  public dateRange = input<string[] | null>(null);

  public isLoading = signal(true);
  public showPopup = false;

  public ticketsByAsset = signal<TopFiveData[]>([]);
  public ticketsByEventName = signal<TopFiveData[]>([]);

  constructor() {
    super();
    this.initEffect();
  }

  private initEffect() {
    effect(
      () => {
        const suspectAssetsData = this.topSuspectAssetsData();
        const assetDetailData = this.topAssetDetailData();
        if (suspectAssetsData && assetDetailData) {
          this.ticketsByAsset.set(suspectAssetsData.slice(0, 5) || []);
          this.ticketsByEventName.set(assetDetailData.slice(0, 5) || []);
          this.isLoading.set(false);
        } else {
          this.ticketsByAsset.set([]);
          this.ticketsByEventName.set([]);
          this.isLoading.set(true);
        }
      },
      { allowSignalWrites: true } as CreateEffectOptions
    );
  }

  public onSeriesClick(event: SeriesClickEvent): void {
    this.seriesClick.emit(event);
  }

  truncateCategoryLabel(args: any): string {
    const label = args.text;
    const maxLength = 20; // Set your desired max length
    return label.length > maxLength ? label.substring(0, maxLength) + '...' : label;
  }

  onContextMenuSelect(event: any) {
    if (event?.text === 'View Data') {
      this.gridService.setDateRange(this.dateRange());
      this.gridService.url = `${environment.apiUrl}/v1/analytics/administrative/slaviolationsdetails(${this.organizationId()})`;
      this.gridService.read();
      this.showPopup = true;
    } else {
      console.warn('Invalid event structure:', event);
    }
  }

  public allData = (): Observable<GridDataResult> => {
    return this.gridService.queryAll();
  };

  // Close popup
  close() {
    this.showPopup = false;
  }
}
